import { render } from "./AcampanteForm.vue?vue&type=template&id=79ffddca&scoped=true"
import script from "./AcampanteForm.vue?vue&type=script&lang=js"
export * from "./AcampanteForm.vue?vue&type=script&lang=js"

import "./AcampanteForm.vue?vue&type=style&index=0&id=79ffddca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ffddca"]])

export default __exports__